import { Grid, Stack, Card } from "@mui/material";
import ButtonElement from "../../../UI/ButtonElement/ButtonElement";
import { useTranslation } from "react-i18next";
import "./ManagementsUpdateNewContact.scss";
import ManagementsCancelProcess from "../../../Managements/ManagementsCancelProcess/ManagementsCancelProcess";
import { useState } from "react";
import { ManagementUpdateCup } from "../../../../core/models/cupsCifSelector/cupsCifSelector.model";
import useUpdateContact from "../../../../core/hooks/managements/contact/useUpdateContact";
import UpdateContactCard from "./UpdateContactCard/UpdateContactCard";
import { SubmitUpdateContactData } from "../../../../core/models/managementsUpdate/managementsUpdateContact/managementsUpdateContact.model";

export interface ManagementsUpdateNewContactProps {
  handleSubmit: SubmitUpdateContactData;
  cupsSelected: ManagementUpdateCup[];
}

const ManagementsUpdateNewContact = ({
  handleSubmit,
  cupsSelected,
}: ManagementsUpdateNewContactProps) => {
  const { t } = useTranslation();

  const {
    contacts,
    handleUpdateContact,
    handleValidateInput,
    isSubmitDisabled,
    getContact,
  } = useUpdateContact(cupsSelected);

  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const listContactCups = contacts.map((cup, i) => (
    <UpdateContactCard
      key={cup.cupsCode}
      cup={cup}
      defaultExpanded={i === 0}
      handleUpdateContact={handleUpdateContact}
      handleValidateInput={handleValidateInput}
      cupIndex={i}
      isDataLoaded={cup.isDataLoaded}
      onChange={() => getContact(cup.cupsContractId)}
    />
  ));

  return (
    <Grid container justifyContent="center" paddingX={2}>
      <Grid item md={8} lg={7} flex={1}>
        <Stack gap={2} className="accordion">
          {listContactCups}
          <Card
            sx={{
              padding: { xs: "8px 0", md: "16px 48px" },
              borderRadius: "8px",
              backgroundColor: { xs: "transparent", md: "white" },
              boxShadow: {
                xs: "none",
                md: "0px 3px 5px 0px rgba(55, 70, 73, 0.20)",
              },
            }}
          >
            <Stack
              display={"flex"}
              direction={{ xs: "column", md: "row" }}
              gap={2}
              justifyContent={"space-between"}
            >
              <ButtonElement
                onClick={() => {
                  handleSubmit(contacts);
                  window.scrollTo({ top: 0, behavior: "auto" });
                }}
                disabled={isSubmitDisabled}
              >
                {t("Gestiones.Actualizar datos")}
              </ButtonElement>
              <ButtonElement type="button" onClick={openModal} secondary>
                {t("Cancelar")}
              </ButtonElement>
            </Stack>
          </Card>
        </Stack>
        <ManagementsCancelProcess open={isModalOpen} handleClose={closeModal} />
      </Grid>
    </Grid>
  );
};

export default ManagementsUpdateNewContact;
